import { computed } from 'vue'

export const formatField = (field, label) => computed(() => field || label.toLowerCase().replace(' ', '_'))
